// extracted by mini-css-extract-plugin
export var logo = "w_0";